import React, { memo, useMemo } from "react";
import { i18n, useLanguage, useThemes } from "core/src";
import { Routes } from "./routes";
import { ThemeProvider } from "react-jss";
import { ConfigProvider, ThemeConfig } from "antd";

const AppContainer = memo(() => {
  const { language } = useLanguage();
  useMemo(() => i18n.changeLanguage(language), [language]);
  const { colors } = useThemes();
  const config: ThemeConfig = {
    token: {
      colorTextDisabled:colors.gray,
      colorPrimary: colors.theme01,
      colorBorder: colors.gray,
      colorBgElevated: colors.black,
      colorText: colors.white,
      colorBgLayout: colors.black,
      colorBorderBg: colors.blue,
      boxShadow:`0px 0px 8px 0.1px ${colors.theme02}`,
    },
    components: {
      Layout: {
        triggerBg: colors.theme02,
        triggerColor: colors.white,
        lightSiderBg: colors.theme02,
        footerBg: colors.theme02,
        triggerHeight: 67,
      },
      Typography: {
        fontSize: 20,
        fontFamily: 'IRANSansX !important'
      },
      Button: {
        colorPrimary: colors.theme01,
        algorithm: true,
      },
      Select: {
        selectorBg: colors.black,
        optionActiveBg: colors.theme01,
        multipleItemBg: colors.orange900,
        multipleItemBorderColor: colors.orangeA100,
        optionSelectedBg: colors.orangeA100,
        optionSelectedColor: colors.white,
        colorBgContainer: colors.theme01,
        colorBgLayout: colors.theme01,
        colorBgElevated: colors.gray600,
      },
      Card: {
        actionsBg: colors.black,
        headerBg: colors.theme01,
        colorBgContainer: colors.black02,
        boxShadowTertiary: `0px 0px 8px 0.1px ${colors.theme02}`,
      },
      Table: {
        headerBg: colors.theme01,
        headerColor: colors.white01,
        colorBgContainer: colors.black02,
       
      },

      Input: {
        colorText: colors.black04,
        activeShadow: `0 0px 8px 1px ${colors.theme01}`,
      },
      Menu:{
        darkItemBg:colors.theme02,
        collapsedIconSize:20,
        itemBg:colors.theme02,
      }
    },
  };
  return (
    <ThemeProvider theme={colors} i18nIsDynamicList>
      <ConfigProvider direction={i18n.dir()} theme={config}>
        <Routes />
      </ConfigProvider>
    </ThemeProvider>
  );
});

export { AppContainer };
